<ngx-spinner
        bdColor="rgba(51,51,51,0.8)"
        size="default"
        color="#fff"
        type="ball-spin-clockwise">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>